import { Controller } from "@hotwired/stimulus"

const CART_KEY = "atombytes_cart"

export default class extends Controller {
  static targets = ["count", "addButton", "item", "cartItems", "emptyState", "populatedState", "summary", "itemCount"]

  static values = { clear: Boolean }

  connect() {
    if (this.clearValue) {
      this.saveCart([])
      this.updateBadge()
      return
    }

    this.updateBadge()
    this.updateButtonStates()
    this.renderCartItems()
  }

  add(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const service = {
      id: button.dataset.serviceId,
      name: button.dataset.serviceName,
      icon: button.dataset.serviceIcon,
      iconColor: button.dataset.serviceIconColor,
      category: button.dataset.serviceCategory
    }

    const cart = this.getCart()

    if (cart.some(item => item.id === service.id)) {
      this.showToast("This service is already in your cart")
      return
    }

    cart.push(service)
    this.saveCart(cart)
    this.updateBadge()

    button.classList.add("added")
    button.innerHTML = '<i class="fas fa-check"></i> Added'

    this.showToast(`"${service.name}" added to cart`)
  }

  remove(event) {
    event.preventDefault()
    const serviceId = event.currentTarget.dataset.serviceId
    let cart = this.getCart()
    cart = cart.filter(item => item.id !== serviceId)
    this.saveCart(cart)
    this.updateBadge()
    this.renderCartItems()
    this.updateButtonStates()
    this.showToast("Service removed from cart")
  }

  getCart() {
    try {
      return JSON.parse(localStorage.getItem(CART_KEY) || "[]")
    } catch {
      return []
    }
  }

  saveCart(cart) {
    localStorage.setItem(CART_KEY, JSON.stringify(cart))
  }

  updateBadge() {
    const count = this.getCart().length
    this.countTargets.forEach(el => {
      el.textContent = count
      el.style.display = count > 0 ? "" : "none"
    })
  }

  updateButtonStates() {
    const cart = this.getCart()
    const cartIds = cart.map(item => item.id)

    this.addButtonTargets.forEach(button => {
      if (cartIds.includes(button.dataset.serviceId)) {
        button.classList.add("added")
        button.innerHTML = '<i class="fas fa-check"></i> Added'
      }
    })
  }

  renderCartItems() {
    if (!this.hasCartItemsTarget) return

    const cart = this.getCart()

    if (cart.length === 0) {
      if (this.hasEmptyStateTarget) this.emptyStateTarget.style.display = ""
      if (this.hasPopulatedStateTarget) this.populatedStateTarget.style.display = "none"
      return
    }

    if (this.hasEmptyStateTarget) this.emptyStateTarget.style.display = "none"
    if (this.hasPopulatedStateTarget) this.populatedStateTarget.style.display = ""

    this.cartItemsTarget.innerHTML = cart.map(item => `
      <div class="cart-item">
        <div class="cart-item-icon">
          <i class="${item.icon}"></i>
        </div>
        <div class="cart-item-info">
          <h4>${this.escapeHtml(item.name)}</h4>
          <p>${this.escapeHtml(item.category.toUpperCase())} Service</p>
        </div>
        <button class="cart-item-remove" data-action="click->cart#remove" data-service-id="${this.escapeHtml(item.id)}" title="Remove">
          <i class="fas fa-trash-alt"></i>
        </button>
      </div>
    `).join("")

    if (this.hasItemCountTarget) {
      const label = cart.length === 1 ? "1 item" : `${cart.length} items`
      this.itemCountTarget.textContent = label
    }

    if (this.hasSummaryTarget) {
      this.summaryTarget.querySelector("[data-cart-count]").textContent =
        cart.length === 1 ? "1 item" : `${cart.length} items`
    }
  }

  escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }

  showToast(message) {
    let toast = document.getElementById("cart-toast")
    if (!toast) {
      toast = document.createElement("div")
      toast.id = "cart-toast"
      toast.className = "toast toast--notice"
      toast.innerHTML = '<div class="toast__content"><i class="fas fa-check-circle toast__icon"></i><span></span></div>'
      document.body.appendChild(toast)
    }

    toast.querySelector("span").textContent = message
    toast.classList.add("show")
    clearTimeout(this._toastTimer)
    this._toastTimer = setTimeout(() => toast.classList.remove("show"), 3000)
  }
}
